<template>
    <b-row class="finance-budget">
        <b-col md="12" class="finance-budget-info">
            <gofix-card class="pt-4">
                <b-row class="mb-3">
                    <b-col cols="3">
                        <gofix-text-field label="Finance Year Start" oneline>
                            {{ budget.budget_year && budget.budget_year.financial_year_start ? budget.budget_year.financial_year_start : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                        </gofix-text-field>
                        
                    </b-col>
                    <b-col cols="4">
                        <gofix-text-field classLabel="width-145" class="width-column" label="Financial Year End" oneline>
                            {{ budget.budget_year && budget.budget_year.financial_year_end ? budget.budget_year.financial_year_end : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                        </gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col cols="3">
                        <gofix-text-field label="Total Budget" oneline>
                            {{ budget.budget_year && budget.budget_year.total_budget ? budget.budget_year.total_budget : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                    <b-col cols="3">
                        <gofix-text-field classLabel="width-145" class="width-column" label="Committed" oneline>
                            {{ budget.budget_year && budget.budget_year.commnited ? budget.budget_year.commnited : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                    <b-col cols="3">
                        <gofix-text-field classLabel="width-65" label="Actual" oneline>
                            {{ budget.budget_year && budget.budget_year.actual ? budget.budget_year.actual : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                    <b-col cols="3">
                        <gofix-text-field label="Balance/Variance" oneline>
                            {{ budget.budget_year && budget.budget_year.balance ? budget.budget_year.balance : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                </b-row>
            </gofix-card>
            <gofix-card :title="titleCard" class="mb-0">
                <b-row class="mt-20 mb-3">
                    <b-col cols="3">
                        <gofix-text-field label="Total Budget" oneline>
                            {{ budget.budget_month && budget.budget_month.total_budget ? budget.budget_month.total_budget : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                    <b-col cols="3">
                        <gofix-text-field classLabel="width-145" class="width-column" label="Committed" oneline>
                            {{ budget.budget_month && budget.budget_month.commnited ? budget.budget_month.commnited : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                    <b-col cols="6">
                        <gofix-text-field classLabel="width-65" label="Actual" oneline>
                            {{ budget.budget_month && budget.budget_month.actual ? budget.budget_month.actual : '' | formatMoney }}
                        </gofix-text-field>
                    </b-col>
                </b-row>
            </gofix-card>
        </b-col>
    </b-row>
</template>
<script>
import moment from 'moment';
export default {
	name: 'tab-budget-order',
	data () {
		return {
            budget: {}
        }
	},
    computed: {
        titleCard() {
            return `Current Month (${moment().format("MM.YYYY")})`;
        }
    },
	created() {
        this.getBudgetInfo();
    },
	methods: {
		getBudgetInfo(){
			this.$store.dispatch('OrderController/getBudgetTab', this.$route.params.id)
            .then(result => {
                this.budget = result
            }).catch(error => {})
		}
	},
}
</script>